import { FieldFunctionOptions, Reference, StoreObject } from '@apollo/client'

export function mergeArrayField<K extends Reference | StoreObject>(
  existing: readonly K[] = [],
  incoming: readonly K[] = [],
  { readField }: FieldFunctionOptions
): K[] {
  const merged: K[] = []
  const seen = new Set<unknown>()

  for (const item of [...existing, ...incoming]) {
    const id = readField('id', item)
    if (id != null && seen.has(id)) continue
    if (id != null) seen.add(id)
    merged.push(item)
  }

  return merged
}
